import Session from '@getpopsure/session';

const apiEndpoint = process.env.NEXT_PUBLIC_FEATHER_API_URL;

function initializeSession() {
  if (typeof window === 'undefined') {
    return;
  }

  const baseURL = apiEndpoint ?? window.location.toString();

  Session.setBaseUrl(baseURL);
  Session.fetchCsrfToken();
}

export default initializeSession;
